// Transpiling and polyfills
// =========================
// Two things going on in builds: 1. Transpiling Babel handles language features while 2. Polyfills handle objects and methods
//
// Q: Why does Object.assign() require a polyfill when babel-loader is being used?
// A: Babel, via babel-loader, transpiles differences in ES6 syntax. Babel on its own does absolutely nothing to add in ES6 standard library functionality
// (like Object.assign). Loading the polyfill loads a separate polyfill core-js for you, but you can load any polyfill you want.
// Even some syntax conversions rely on specific polyfill functionality to be loads, since some syntax relies on algorithms and behaviors
// implemented in library code. The ES6 features on http://babeljs.io/docs/learn-es2015/ each list what standard library functionality are assumed to have been loaded.

// Polyfills for supporting the needs of Bootstrap-vue.js for e.g. IE11
// Instructions from here https://bootstrap-vue.js.org/docs/#js
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer' // Optional

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// SEO tags / OpenGraph - see App.vue for default config and other templates for any overrides
import Meta from 'vue-meta';
import VueStash from 'vue-stash';

// Bootstrap
import {
  Badge,
  Button,
  Card,
  Collapse,
  FormCheckbox,
  FormGroup,
  FormInput,
  FormTextarea,
  FormSelect,
  Image,
  Link,
  Layout, // row col container etc
  Modal,
  Progress,
} from 'bootstrap-vue/es/components';

import vBTooltip from 'bootstrap-vue/es/directives/tooltip/tooltip';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import SocialSharing from 'vue-social-sharing';

// only import the icons you use to reduce bundle size
// using the icons from the regular set since wanted hollow, so here in /regular/ dir and in the v-icon names they are referenced via 'regular/...'
// https://github.com/Justineo/vue-awesome

// REGULAR / HOLLOW
import 'vue-awesome/icons/regular/check-square';
import 'vue-awesome/icons/regular/square'; // hollow
import 'vue-awesome/icons/regular/frown'; // hollow
import 'vue-awesome/icons/regular/plus-square'; // hollow

// SOLID (default icon path in v-icon (e.g. name="square")
import 'vue-awesome/icons/square'; // solid
import 'vue-awesome/icons/arrow-alt-circle-right'; // solid
import 'vue-awesome/icons/plus'; // solid
import 'vue-awesome/icons/quote-left'; // solid
import 'vue-awesome/icons/quote-right'; // solid

import 'vue-awesome/icons/chevron-down';
import 'vue-awesome/icons/chevron-up';

import 'vue-awesome/icons/info-circle'; // solid

import 'vue-awesome/icons/brands/twitter'; // solid
import 'vue-awesome/icons/brands/facebook-square'; // solid
import 'vue-awesome/icons/brands/whatsapp'; // solid
import 'vue-awesome/icons/envelope'; // solid
import 'vue-awesome/icons/brands/reddit'; // solid

import Icon from 'vue-awesome/components/Icon';

// simple error toasts
import Toasted from 'vue-toasted';

Vue.config.productionTip = false

// globally (in your main .js file)
Vue.component('v-icon', Icon);

// Meta tags for opengraph etc
// Use by setting a Metainfo() attribute in any component
Vue.use(Meta);

// If Bootstrap is the only thing relying on jQuery, you can safely remove it — BootstrapVue does NOT depend on jQuery
// even though the npm install says it does depend on it as peer
// ALL Vue.use(BootstrapVue);
// This is part of importing <b-modal> as well as the v-b-modal directive as a plugin:
// Vue.use(BootstrapVue);

Vue.use(Badge);
Vue.use(Button);
Vue.use(Card);
Vue.use(Collapse);
Vue.use(FormGroup);
Vue.use(FormInput);
Vue.use(FormTextarea);
Vue.use(FormSelect);
Vue.use(FormCheckbox);
Vue.use(Image);
Vue.use(Layout);
Vue.use(Link);
Vue.use(Modal);
Vue.use(Progress);
Vue.directive('b-tooltip', vBTooltip);

// simple state mgmt
// http://vuetips.com/simple-state-management-vue-stash
Vue.use(VueStash);

// https://github.com/shakee93/vue-toasted
// Use with this.$toasted.show(''), this.$toasted.info(''), this.$toasted.error('')
Vue.use(Toasted, {
  position: 'top-center',
  duration: 12000,
  // fullWidth: true,
  theme: 'bubble',
  action: {
    text: 'Close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
  singleton: true,
});

// Buttons for social sharing
Vue.use(SocialSharing);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    store: { // vue-stash store http://vuetips.com/simple-state-management-vue-stash
      person: {
        email: null,
        name: null,
        extras: {
          organisationName: null, // only entered when person registers from some quests
          permissionNewsletter: false,
          country: null, // added to answers as well as person
          comment: null, // comment
          emailCopy: null, // the other email is not stored in fMP and we are not adding to MailChimp so this is needed to hold the emails for now.
        },
      },
      stats: {}
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js